import React, { useEffect, useState } from "react";
import { lensPath, lensProp } from "ramda";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../../util/ext";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: "1.8rem",
  },
}));

const CustomFieldsDialog = ({ fieldOptions, open, onCancel, onApply }) => {
  const classes = useStyles();
  const [fields, setFields] = useState({
    customFreeformLabel: null,
    customFreeformRequired: false,
  });

  useEffect(() => {
    if (notBlank(fieldOptions["custom_freeform"])) {
      setFields({
        customFreeformLabel: fieldOptions["custom_freeform"].fieldLabel || null,
        customFreeformRequired:
          fieldOptions["custom_freeform"].required || false,
      });
    }
  }, [fieldOptions]);

  const handleTextChange = path => event => {
    const value = event.target.value;
    setFields(prev => set(lensPath(path), value, prev));
  };

  const handleCheckboxChange = field => event => {
    const value = event.target.checked;
    setFields(prev => set(lensProp(field), value, prev));
  };

  const handleApply = async () => {
    onApply(fields);
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">Edit Custom Field</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter properties for the Custom Freeform field.
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="custom-freeform-label"
              fullWidth
              label="Custom Freeform Label"
              InputProps={{
                classes: { root: classes.title },
              }}
              value={fields.customFreeformLabel}
              onChange={handleTextChange(["customFreeformLabel"])}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={fields.customFreeformRequired}
                  onChange={handleCheckboxChange("customFreeformRequired")}
                  name="custom-freeform-required"
                  inputProps={{ "aria-label": "Select" }}
                />
              }
              label="Custom Freeform Required"
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomFieldsDialog;
